import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '~/store/modules';
import jwtDecode from 'jwt-decode';

import { getProfile } from '~/store/modules/_ui/auth/selectors';
import { useTokenStore } from '~/store/modules/token/useTokenStore';

type AccessData = {
  veiling_claim_type_email: string;
  veiling_claim_type_identifier: string;
  veiling_claim_type_name: string;
  veiling_claim_type_role: string;
};

export function useEnsureProfile() {
  const dispatch = useDispatch();
  const profile = useSelector(getProfile);

  useEffect(() => {
    if (!profile || !profile.veiling_claim_type_name) {
      const accessToken = useTokenStore.getAccess();
      if (accessToken) {
        const accessData = jwtDecode<AccessData>(accessToken);
        dispatch(
          actions.ui.auth.setProfile({
            veiling_claim_type_email: accessData.veiling_claim_type_email,
            veiling_claim_type_identifier: accessData.veiling_claim_type_identifier,
            veiling_claim_type_name: accessData.veiling_claim_type_name,
            veiling_claim_type_role: accessData.veiling_claim_type_role,
          }),
        );
      }
    }
  }, [dispatch, profile]);

  return profile;
}
